import React, { useContext } from "react";
import { useSelector } from "react-redux";
import { SafeAreaView, Platform } from "react-native";
import { formatNumber } from "digiwash-core";
import {
  Typography,
  OldButton as Button,
  Stack,
  Spacer,
  Float,
  Box,
} from "digiwash-components";

import Icon from "../Icon";
import userSelectors from "../../ducks/user/selectors";
import { LoginContext } from "../../contexts/login";
import { EVENT_TYPES, logEvent } from "../../helpers/analytics-helper";
import useNavigation from "../../hooks/useNavigation";
import CustomIcon from "../CustomIcon";
import useCart from "../../ducks/cart/hooks/useCart";
import { CartRetrieveOutput } from "../../ducks/cart/cart-types";
import { iosSafeArePadding } from "../../helpers/general";

let pb = 0;
if (Platform.OS === "android") {
  pb = 0;
} else if (Platform.OS === "web") {
  pb = 24;
}

const webStyles = {
  container: {
    maxWidth: 768,
    margin: "auto",
    width: "100%",
    left: "50%",
    transform: "translateX(-50%)",
  },
  innerContainer: {
    // maxWidth: 768,
    // margin: "auto",
    // width: "100%",
    paddingBottom: iosSafeArePadding(),
  },
  extraSpace: {
    paddingBottom: 64,
  },

  stackProps: { pb: "l" },
};

let nativeStyles = {
  stackProps: { pb: "l" },
  container: {},
  innerContainer: {},
  safeAreStyles: {
    paddingBottom: pb,
  },
};
let overrideStyles = Platform.OS === "web" ? webStyles : nativeStyles;
let styles = {
  ...overrideStyles,
};

let Container = Platform.OS === "web" ? Box : SafeAreaView;

interface PropTypes {
  extraSpaceFromBottom?: boolean;
}

function BasketFloatButton(props: PropTypes) {
  let { isLoginModalOpen, setLoginModalOpen } = useContext(LoginContext);
  let isAuthenticated: boolean = useSelector(userSelectors.getToken);
  let nav = useNavigation();
  let { retrieve: retrieveCart } = useCart();
  let cart: CartRetrieveOutput = retrieveCart({ force: true });

  let hasData = !!cart?.data?.services;
  let isEmpty = !hasData || cart?.data?.services?.length === 0;

  let floatStyles = {
    width: "100%",
    ...styles.container,
  };

  if (props.extraSpaceFromBottom) {
    floatStyles = {
      ...floatStyles,
      ...styles.extraSpace,
    };
  }
  return (
    <Container
      style={{
        ...styles.safeAreStyles,
        ...styles.innerContainer,
      }}
    >
      <Float px="xxl" style={floatStyles}>
        {isEmpty ? null : (
          <Box
            style={{
              paddingBottom: iosSafeArePadding(),
            }}
          >
            <Stack {...styles.stackProps}>
              <Button
                onPress={() => {
                  if (!isAuthenticated) {
                    setLoginModalOpen(!isLoginModalOpen);
                  } else {
                    nav.navigate("Basket");
                  }
                }}
                bg="primary.main"
                size="m"
                type="circle-like"
              >
                <Stack>
                  <CustomIcon icon="orderBasket" width={32} height={32} />
                  <Spacer size="m" />
                  <Typography color="common.white" ff="mainBold">
                    {formatNumber(cart?.data?.services?.length)} مورد
                  </Typography>
                  <Spacer size="m" />
                  <Icon name="chevron-left" color="common.white" size={20} />
                </Stack>
              </Button>
            </Stack>
          </Box>
        )}
      </Float>
    </Container>
  );
}

export default BasketFloatButton;
